import React from 'react';

const LinkExpiredScreen = () => {
  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h2>Link Expired</h2>
      <p>The link you're trying to access has expired.</p>
      <p>Please contact support for assistance.</p>
    </div>
  );
};

export default LinkExpiredScreen;
